import React from 'react';
import classNames from 'classnames/bind';
import styles from './product-quote-center.style.scss';

const cx = classNames.bind(styles);

export const ProductQuoteCenter = () => {
  return (
    <div className={cx('product-quote-center__wrapper')}>
      <div className={cx('product-quote-center__container')}>
        <div className={cx('product-quote-center__title')}>
          Visit Pro Desk
        </div>
        <div className={cx('product-quote-center__description')}>
          Please visit the Pro Desk at your local store to discuss pricing and
          availability of this special order product.
        </div>
      </div>
    </div>
  );
};
